import {OPEN_MENU} from '../actions'

export function handle(currentState = {open: true}, action) {
    if (action.type === OPEN_MENU) {
        return {
            open: !currentState.open
        }
    }
    return currentState
}